<div id="panel-card">
  <div *ngFor="let item of control; let index = i">
    <p-card [header]="item.nombre" [subheader]="item.descripcion" (click)="navegar(item.id)" styleClass="ui-card-shadow">
      <p-header>
        <img *ngIf="item.foto == null || item.foto.length === 0"
          style="min-height: 300px; max-height: 300px; object-fit: cover;" src="assets/img/no-hay-foto.png">
        <img *ngIf="item.foto != null && item.foto.length > 0"
          style="min-height: 300px; max-height: 300px; object-fit: cover;" [src]="urlImagen + item.foto">
      </p-header>

      <div>
        <span>{{item.color ? item.color + ' | ': ''}}  {{item.maceta}} <br> {{item.tamano}}</span>
      </div>
    </p-card>
  </div>
</div>

<div id="btn-add" (click)="createArticle()">
  Añadir articulo
</div>